<template>
  <div class="optionBlocage__general">
    <div class="planningOptionBlocage planningTailleColonnePlanning background-image-none"
         style="min-width: max-content;">
      <div class="disponibiliteSemaine align-items-flex-end">
        <div class="disponibilite is-paddingless background-image-none has-background-white card">
          <div class="shape ellipsis is-marginless" :style="calculStyleCellule">
            <div class="vertical-alignement has-text-black">
              {{ ligneCommande.ligneReseau.qteFacesPrevues - nbFaceNonDispo }}
              / {{ ligneCommande.ligneReseau.qteFacesPrevues }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="etatSouhaite">
      <b-field :label="$t('optionBlocage.etatSouhaite')"
               custom-class="is-marginless ellipsis has-text-link is-size-7">
        <b-select expanded v-model="ligneCommande.etatSouhaite" :disabled="disabled"
                  @input="initialiseEtat()">
          <option v-for="status in ETAT_SOUHAITE"
            :key="status.key"
            :value="status.key">
            {{$t(status.libelle)}}
          </option>
        </b-select>
      </b-field>
    </div>

    <div class="etatResultat is-flex align-items-flex-end">

      <b-field :label="$t('optionBlocage.etatObtenu')" class="width-100percent"
               v-if="ligneCommande.etatObtenu !== AUCUN"
               custom-class="is-marginless ellipsis has-text-link is-size-7">
        <b-input :value="$t(getEtat('etatObtenu'))"
          expanded disabled></b-input>
      </b-field>
      <b-field :label="$t('optionBlocage.etatProvisoire')"
               custom-class="is-marginless ellipsis has-text-link is-size-7"
               v-else-if="ligneCommande.etatSouhaite!== AUCUN"
               style="position: relative">
        <b-input :value="$t(getEtat('etatProvisoire'))"
                  expanded disabled custom-class="inputBackgroundColorProvisoire">
          </b-input>
      </b-field>
    </div>

    <div class="rangInfo" v-if="ligneCommande.rangOption && !ligneCommande.etatDeLaDemande">
      <b-field :label="$t('optionBlocage.rang')"
               class="max-width-60"
               custom-class="is-marginless ellipsis has-text-link is-size-7">
        <b-input expanded disabled :value="ligneCommande.rangOption" type="number"></b-input>
      </b-field>
    </div>
    <div class="rangInfo"
      v-if="ligneCommande.rangOptionProvisoir && ligneCommande.etatDeLaDemande">
      <b-field :label="$t('optionBlocage.rang')"
               class="max-width-60"
               custom-class="is-marginless ellipsis has-text-link is-size-7">
        <b-input expanded disabled :value="ligneCommande.rangOptionProvisoir" type="number">
        </b-input>
      </b-field>
    </div>

    <div class="messageInfo has-text-danger is-flex align-items-flex-end"
         v-if="ligneCommande.messagesAvertissement">
      <span class="columns is-marginless is-vcentered is-multiline full-width">
        <span class="column is-narrow" v-if="!messagesAvertissement">
          {{ $t(ligneCommande.messagesAvertissement) }}
        </span>
        <span class="column is-narrow"
          v-for="(mess, index) in !messagesAvertissement
            ? [] : ligneCommande.messagesAvertissement"
          :key="index">
          {{ $t(mess) }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  ETAT_SOUHAITE,
  ETAT_OBTENU,
  AUCUN,
  ATTENTE_REPONSE,
  BLOQUE,
} from '@/configuration/optionBlocage/optionBlocage';
import calculateStyleCelluleEtatObtenu from '@/services/planningReseauTempo/calculateStyleCelluleEtatObtenu';
import messageErreur from '@/services/general/messageErreur';
import simulationEtatObtenu from '@/services/devisCommandes/optionBlocage/simulationEtatObtenu';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getLignesSelectionFace } from '@/services/dcf/reseauTempo/getListeFacesForSelection';

const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'optionBlocage',
  props: {
    ligneCommande: {
      type: Object,
      required: true,
      default: null,
    },
    devisCommande: {
      type: Object,
      required: true,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      ETAT_SOUHAITE: ETAT_SOUHAITE,
      AUCUN: AUCUN,
    };
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    nbFaceNonDispo() {
      let nbFacesNonDispo = 0;
      if (!this.ligneCommande.affectation) return nbFacesNonDispo;

      this.ligneCommande.affectation
        .filter((affectation) => {
          return affectation.referenceId !== this.devisCommande.id
            && affectation.rangOption === null;
        })
        .forEach((affectationReseauTempo) => {
          nbFacesNonDispo += affectationReseauTempo.nbFaces;
        });

      return nbFacesNonDispo;
    },
    calculStyleCellule() {
      return calculateStyleCelluleEtatObtenu({
        allAffectationOfProduct: this.ligneCommande.affectation
          .filter((affectation) => {
            return affectation.referenceId !== this.devisCommande.id;
          }),
        stock: this.ligneCommande.ligneReseau.qteFacesPrevues,
      });
    },
    messagesAvertissement() {
      return Array.isArray(this.ligneCommande.messagesAvertissement);
    },
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getEtat(libelle) {
      if (this.ligneCommande[libelle] === ATTENTE_REPONSE) return 'optionBlocage.attenteReponse';
      return ETAT_OBTENU.find((status) => {
        return status.key === this.ligneCommande[libelle];
      }).libelle;
    },
    async initialiseEtat() {
      this.ligneCommande.etatProvisoire = AUCUN;
      this.ligneCommande.rangOptionProvisoir = null;
      this.ligneCommande.etatObtenu = AUCUN;
      this.ligneCommande.messagesAvertissement = null;
      this.ligneCommande.rangOption = null;
      this.ligneCommande.ligneReseau.lignesCmdSelProduits = [];
      this.ligneCommande.lignesCommande.forEach((ligne) => {
        ligne.etatObtenu = AUCUN;
      });
      this.ligneCommande.etatDeLaDemande = true;
      await this.simulationEtatObtenuAsync();
      await this.gestionLigneCmdSelOption();
      this.$emit('reloadTotalHt');
    },
    simulationEtatObtenuAsync() {
      try {
        simulationEtatObtenu(this.ligneCommande, this.devisCommande.societeId
          ? this.devisCommande.societeId : this.societeActiveId);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async gestionLigneCmdSelOption() {
      this.$emit('loadingFaces', true);
      try {
        if (this.ligneCommande.etatSouhaite === BLOQUE
          && this.ligneCommande.lignesCmdSelOptionProduit?.length) {
          const lignesSel = await getLignesSelectionFace(this.ligneCommande, true,
            this.users, this.societeActiveId, false);
          const lignesSelDispo = lignesSel.filter(r => r.selected && r.dispo).map(r => ({
            anneeSemaine: this.ligneCommande.ligneReseau.anneeSemaine,
            produitId: r.produitId,
            reference: r.reference,
            instructionPose: r.instructionPose,
          }));
          this.ligneCommande.ligneReseau.lignesCmdSelProduits = lignesSelDispo;
          const hasLignesIndispo = this.ligneCommande.lignesCmdSelOptionProduit
            .map(l => l.produitId)
            .some(id => !lignesSelDispo.some((r) => r.produitId === id));
          this.ligneCommande.messagesAvertissement = !hasLignesIndispo ? null
            : ['optionBlocage.messageErreurFacesIndisponiblesEnBlocage'];
        }
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.$emit('loadingFaces', false);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
